import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Application, ApplicationApi } from '@classes/application/application';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  applications: Application[] = [
    {
      id: 0,
      appName: 'SmartParking',
      description: 'Parking management',
      iconType: 'faIcon',
      iconName: 'faCar',
      url: '/smartparking'
    },
    {
      id: 1,
      appName: 'SmartWaste',
      description: 'Waste dumping detection',
      iconType: 'faIcon',
      iconName: 'faGlobeEurope',
      url: '/smartwaste'
    },
    {
      id: 2,
      appName: 'Administration',
      description: 'Application administration',
      iconType: 'faIcon',
      iconName: 'faCog',
      url: '/admin'
    }
  ];

  constructor(
    private http: HttpClient
  ) { }


  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getAllApplications(): Observable<ApplicationApi[]> {
    return this.http.get<ApplicationApi[]>(`${environment.apiUrl}/applications`, {
      headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` }
    })
  }
}
